module.exports = __webpack_public_path__ + "images/company_profile/icon08-8768ed61b9b4270fc32eabb36f5bbabd.png";